
import {Component} from 'vue-property-decorator';
import BaseFilter from './BaseFilter';

@Component({
  name: 'catalog-product-list-attribute-filter',
})

export default class extends BaseFilter {
  public created(): void {
    super.created();
  }

  private get sortedFilterOptions(): Array<object> {
    return this.filter['options'].sort((a, b) => a.label.localeCompare(b.label));
  }
}
